import '@backstage/ui/css/styles.css';
import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { catalogDevopsPlugin } from '@internal/backstage-plugin-catalog-devops';
import { devopsRbacPlugin } from '@internal/backstage-plugin-devops-rbac';
import { navModule } from './modules/nav';
import { rootModule } from './modules/rootContextProvider';
import { signInModule } from './modules/signInPage';
import { HomePage } from '@internal/backstage-plugin-catalog-devops';
import homePlugin from '@backstage/plugin-home/alpha';
import { catalogDevopsModuleClustersPlugin } from '@internal/backstage-plugin-catalog-devops-module-clusters';
import { catalogDevopsModuleIntegrationsPlugin } from '@internal/backstage-plugin-catalog-devops-module-integrations';
import { apiModule } from './apis';
import { devopsSpmPlugin } from '@internal/backstage-plugin-devops-spm';
import { catalogModule } from './modules/catalog';
import { homeModule } from './modules/home';

const homePagePluginOverride = homePlugin.withOverrides({
  extensions: [
    homePlugin.getExtension('page:home').override({
      params: {
        loader: async () => <HomePage />,
      },
    }),
  ],
});

const app = createApp({
  features: [
    catalogDevopsPlugin,
    catalogDevopsModuleClustersPlugin,
    catalogDevopsModuleIntegrationsPlugin,
    devopsRbacPlugin,
    devopsSpmPlugin,
    catalogPlugin,
    homePagePluginOverride,
    homeModule,
    apiModule,
    catalogModule,
    navModule,
    rootModule,
    signInModule,
  ],
});

export default app.createRoot();
